// Session
export const GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS';
export const GET_SESSION_ERROR = 'GET_SESSION_ERROR';
export const GET_USER_SESSION_SUCCESS = 'GET_USER_SESSION_SUCCESS';

// Student actions
export const FETCH_STUDENTS = 'FETCH_STUDENTS';
export const GET_STUDENTS_SUCCESS = 'GET_STUDENTS_SUCCESS';
export const GET_STUDENTS_ERROR = 'GET_STUDENTS_ERROR';
export const FETCH_STUDENT = 'FETCH_STUDENT';
export const GET_STUDENT_SUCCESS = 'GET_STUDENT_SUCCESS';
export const GET_STUDENT_ERROR = 'GET_STUDENT_ERROR';

// Bid actions
export const GET_BIDS_SUCCESS = 'GET_BIDS_SUCCESS';

// Agreement actions
export const GET_AGREEMENTS_SUCCESS = 'GET_AGREEMENTS_SUCCESS';

// Cycle actions
export const GET_CYCLES_SUCCESS = 'GET_CYCLES_SUCCESS';

// Grade instance actions
export const GET_GRADE_INSTANCES_SUCCESS = 'GET_GRADE_INSTANCES_SUCCESS';

// Parent actions
export const CHECK_PARENT_SUCCESS = 'CHECK_PARENT_SUCCESS';
export const CHECK_PARENT_ERROR = 'CHECK_PARENT_ERROR';
export const CLEAN_SEARCH_PARENT = 'CLEAN_SEARCH_PARENT';

// Reports
export const FETCH_REPORTS = 'FETCH_REPORTS';
export const FETCH_REPORTS_SUCCESS = 'FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_ERROR = 'FETCH_REPORTS_ERROR';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js